import * as types from './actionTypes'

export const addContact = (data) => ({
  type: types.ADD_CONTACT,
  payload: data,
})